import { useIntl, defineMessages } from 'dibs-react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { setShipmentNotesAction } from '../actions/commonActions';
import { trackUserInteractionOnce } from '../helpers/checkoutTracking';
import { VARS } from '../constants/checkoutConstants';
import { TextArea } from 'dibs-elements/exports/TextArea';
import styles from './styles/buyerShipmentRequest.scss';
import { connect } from 'react-redux';

// components
import CheckoutShipmentNotes from './CheckoutShipmentNotes';

const messages = defineMessages({
    textAreaLabel: {
        id: 'BuyerShipmentRequest.textAreaLabel',
        defaultMessage: 'Add special instructions or requests',
    },
});

const BuyerShipmentRequest = props => {
    const intl = useIntl();

    function onChange(event) {
        const { value: shipmentNotes = '' } = event.target;
        trackUserInteractionOnce();
        props.onUpdateShipmentNotes({ shipmentNotes });
    }

    function onBlur() {
        const shipmentNotes = (props.shipmentNotes || '').trim() || null;
        props.onUpdateShipmentNotes({ shipmentNotes });
    }

    const {
        buyer,
        deliveryOptions,
        shipmentNotes,
        isShipmentNoteOpen,
        isCustomQuoteSelected,
        hasCustomQuoteError,
    } = props;

    const textAreaClasses = classNames({
        [styles.textArea]: true,
        [styles.error]: hasCustomQuoteError,
    });

    return (
        <>
            <CheckoutShipmentNotes
                {...{
                    buyer,
                    deliveryOptions,
                }}
            />
            {isShipmentNoteOpen && (
                <TextArea
                    ariaLabel={intl.formatMessage(messages.textAreaLabel)}
                    name="textArea"
                    onChange={onChange}
                    onBlur={onBlur}
                    dataTn="buyer-shipment-request-textarea"
                    maxLength={VARS.MAX_NOTE_LENGTH}
                    rows={4}
                    value={shipmentNotes || ''}
                    autoFocus={isCustomQuoteSelected && !shipmentNotes}
                    className={textAreaClasses}
                />
            )}
        </>
    );
};

BuyerShipmentRequest.propTypes = {
    buyer: PropTypes.object,
    deliveryOptions: PropTypes.array,
    shipmentNotes: PropTypes.string,
    isShipmentNoteOpen: PropTypes.bool.isRequired,
    isCustomQuoteSelected: PropTypes.bool.isRequired,
    hasCustomQuoteError: PropTypes.bool.isRequired,
    allowCustomQuote: PropTypes.bool.isRequired,
    onUpdateShipmentNotes: PropTypes.func.isRequired,
};

const ConnectedBuyerShipmentRequest = connect(
    ({ transaction, delivery }) => ({
        isShipmentNoteOpen: delivery.isShipmentNoteOpen,
        isCustomQuoteSelected: delivery.isCustomQuoteSelected,
        hasCustomQuoteError: delivery.hasCustomQuoteError,
        shipmentNotes: transaction.shipmentNotes,
    }),
    { onUpdateShipmentNotes: setShipmentNotesAction }
)(BuyerShipmentRequest);

export default createFragmentContainer(ConnectedBuyerShipmentRequest, {
    buyer: graphql`
        fragment BuyerShipmentRequest_buyer on User {
            ...CheckoutShipmentNotes_buyer
        }
    `,
    deliveryOptions: graphql`
        fragment BuyerShipmentRequest_deliveryOptions on ShipmentQuote @relay(plural: true) {
            ...CheckoutShipmentNotes_deliveryOptions
        }
    `,
});
